// Posting utilities
// IMPORTANT: Character count is for visualization only.
// Do NOT gate posting by character length. Backends and platform flows
// already handle over-limit cases gracefully.

export const MAX_CHARS_FOR_UI = 300; // Visual baseline only

export function canAttemptPost(plainText: string, posting: boolean): boolean {
  if (posting) return false;
  return !!plainText.trim();
}

export function getPlatformWarnings(
  plainText: string,
  platformMaxChars: Record<string, number | undefined>
): string[] {
  const length = plainText.length;
  const warnings: string[] = [];
  for (const [platform, max] of Object.entries(platformMaxChars)) {
    if (typeof max === 'number' && length > max) {
      warnings.push(`${platform}: +${length - max}`);
    }
  }
  return warnings;
}


